import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

const AntModal = (props) => <Modal {...props} />;

const isoModal = styled(AntModal)`
  .ant-modal-close-icon {
    font-size: 20px;
    color: var(--khmer-curry);
  }

  .ant-modal-title {
    color: var(--carbon);
  }

  .ant-modal-body {
    padding: 36px;
    color: var(--carbon);
  }
`;

export default isoModal;
